import React, { Component } from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { Divider } from '../../../assets/UIElements'
import * as Icons from '../../../assets/Icons'
import { Paragraph, Tip } from '../../../assets/Text'
import { Icon } from '../../../assets/Buttons'
import { ConfirmBox } from '../../../assets/Feedback'
import GetImg from '../../../assets/GetImg'
import ProfileCard from './ProfileCard'
import ResetPass from '../Auth/ResetPass'
import EditProfile from '../Auth/EditProfile'
import SupportiveMessages from './SupportiveMessages'
import AuthenticationHelper from '../../../helpers/AuthenticationHelper'
import UserProfileHelper from '../../../helpers/UserProfileHelper'
import UserInteractionHelper from '../../../helpers/UserInteractionHelper'

class Profile extends Component {
    _isMount = false
    constructor(props)
    {
        super(props)
        this.state = {
            modalComponent: null,
            loaded: false,
            supportiveMsgSender: {},
            supportiveMsgReceiver: {}
        }
        this.initEditProfile = this.initEditProfile.bind(this)
        this.initResetPass = this.initResetPass.bind(this)
    }

    async componentDidMount()
    {
        this._isMount = true
            const profile = await UserProfileHelper.getProfileById(AuthenticationHelper.uuid)
            const authProfile = await UserProfileHelper.getAuthProfileById(AuthenticationHelper.uuid)
            
            try
            {
                const userContacts = await UserInteractionHelper.getContactSentByUserId(AuthenticationHelper.uuid)
                // const requestedToContact = await UserInteractionHelper.getContactByUserId(AuthenticationHelper.uuid)
                let contacts = [], noRepeat = []
                // console.log(requestedToContact)
                // console.log("contacts before loop",userContacts)
                // if (requestedToContact.hasOwnProperty('data') && requestedToContact.data !== null && this._isMount) {
                //     contacts = contacts.concat(requestedToContact.data)
                //     // contacts.push(requestedToContact.data)
                //     // contacts.push(userContacts.data)
                //     // console.log(userContacts.data)
                // }
                if (userContacts.hasOwnProperty('data') && userContacts.data !== null && this._isMount) {
                    contacts = contacts.concat(userContacts.data)
                    // contacts = [...userContacts.data]
                    // contacts.push(userContacts.data)
                    // console.log(userContacts.data)
                    // await this.props.updateConnectedUsers(userContacts.data)
                }
                // noRepeat = [...contacts]
        
                noRepeat = []
                const idIndex = {}, idIndex2 = {}
                contacts.forEach((item, index) => {
                    if (
                        noRepeat.findIndex(contact => contact.reciever_id === item.sender_id && contact.sender_id === item.reciever_id) === -1 && // remove sender, reciever cross match items
                        noRepeat.findIndex(contact => contact.sender_id === item.sender_id && contact.reciever_id === item.reciever_id) === -1     // remove same sender reciever items
                    ) {
                        noRepeat.push(item)
                        if(item?.sender_id) idIndex[item.sender_id] = item
                        if(item?.reciever_id) idIndex2[item.reciever_id] = item
                    }
                })
                // console.log("contacts after loop", contacts)
                // console.log("contacts no repeat", noRepeat)
                // console.log("idx index", idIndex)
                // await this.props.updateConnectedUsers(noRepeat)
                // await this.props.loopConnectedUsers(noRepeat)
                this.setState({
                    supportiveMsgSender: idIndex,
                    supportiveMsgReceiver: idIndex2
                })
    
                // console.log("connected users", this.props.connectedUsersJsonIdx)
            }
            catch(e)
            {
                // console.log("Failed to get connected users", e)
            }


            if(profile.hasOwnProperty('data'))
            {
                let profileData = profile.data
                if(authProfile.hasOwnProperty('status') && authProfile.status === 'success' && authProfile.hasOwnProperty('data'))
                {
                    profileData['email'] = authProfile.data.username
                }
                await this.props.updateProfile(profileData)
            }

            // check if user is resetting password
            const status= await UserProfileHelper.getRoleById(AuthenticationHelper.uuid)
            // console.log(status)
            if (Object.keys(status).length > 0 && status.hasOwnProperty('data') && status.data.status ===2)
            {
                this.initResetPass()
            }

            // console.log("profile",profile)
            const userHugs = await UserInteractionHelper.getHugsRecievedByUserId(AuthenticationHelper.uuid)
            
            console.log("userHugs response:", userHugs)
            
            if(userHugs.hasOwnProperty('data') && userHugs.data !== null && Array.isArray(userHugs.data))
            {
                console.log("updating hugs with:", userHugs.data)
                await this.props.updateHugs(userHugs.data)
            }
            else if(userHugs.hasOwnProperty('data') && Array.isArray(userHugs.data) && userHugs.data.length === 0)
            {
                // Empty array case - user has no hugs yet
                console.log("no hugs yet, updating with empty array")
                await this.props.updateHugs([])
            }
            const userSupportMsg= await UserInteractionHelper.getSupportMsgRecievedByUserId(AuthenticationHelper.uuid)
            if(userSupportMsg.hasOwnProperty('data'))
            {
                // console.log(userSupportMsg)
                await this.props.updateSupportMessages(userSupportMsg.data)
            }
            this.setState({
                loaded: true
            })
    }

    initEditProfile()
    {
        this.setState({
            modalComponent: <EditProfile updateProfile={this.props.updateProfile} profile={this.props.profile} langEdit={this.props.langEdit} selectedLang={this.props.selectedLang} />
        }, () => {
            this.props.initConfirmMessage({
                title: this.props.lang.profile.editProfile,
                value: this.props.lang.profile.editProfileWarning
            })
        })

    }

    initResetPass()
    {
        this.setState({
            modalComponent: <ResetPass email={this.props.profile.email} lang={this.props.lang.profile} />
        }, () => {
            this.props.initConfirmMessage({
                title: this.props.lang.profile.resetPass,
                value: this.props.lang.profile.resetPassWarning
            })
        })
    }

    componentWillUnmount()
    {
        this._isMount = false
    }

    render()
    {  
        if(!this.props.hasOwnProperty('profile') 
        || !this.props.profile.hasOwnProperty('display_name') 
        || !this.props.profile.hasOwnProperty('age') 
        || !this.props.profile.hasOwnProperty('gender')
        || !this.props.profile.hasOwnProperty('state_address') 
        || !this.props.profile.hasOwnProperty('loss_description')
        || !this.props.profile.hasOwnProperty('study_field')
        || !this.props.profile.hasOwnProperty('problem_category_1')
        || !this.props.profile.hasOwnProperty('problem_category_2')
        || !this.props.profile.hasOwnProperty('problem_category_3')
        || !this.props.profile.hasOwnProperty('hobbies_description')
        || !this.props.profile.hasOwnProperty('coping_strategy_1')
        || !this.props.profile.hasOwnProperty('coping_strategy_2')
        || !this.props.profile.hasOwnProperty('coping_strategy_3')
        )
        {
            return <CircularProgress />
        }
        let lang = this.props.lang.profile
        let supportiveMessages = []
        if(this.props.hasOwnProperty('supportiveMessages') && this.props.supportiveMessages !== null)
        {   
            // console.log('msgs ', this.props.supportiveMessages)
            this.props.supportiveMessages.map((msg, idx) => {
                // console.log(`the sender id is ${msg.sender_id}`, this.props.connectedSenderIdJsonIdx)
                // Handle both user-to-user and AI onboarding support messages
                // User messages have sender_display_name, AI messages may not have it
                const displayName = msg.sender_display_name || msg.bot_name || 'AI'
                supportiveMessages.push(<SupportiveMessages 
                    key={`match-supportive-messages-${idx}`} 
                    userId={AuthenticationHelper.uuid} 
                    senderId={msg?.sender_id} 
                    connected={this.state.supportiveMsgSender.hasOwnProperty(msg?.sender_id) || this.state.supportiveMsgReceiver.hasOwnProperty(msg?.sender_id)} 
                    display_name={displayName} 
                    message={msg.message} time={msg.sent_time}
                    lang={lang}
                />)
            })
        }
        return (<Box
            sx={{ width: '100%', maxWidth: {
                    xs: 'xs',
                    sm: 'md',
                    md: 'md',
                    lg: 'md',
                    xl: 'md'
                }, 
                // px: 2,
                mx: 'auto'
            }}
        >
        <Grid container direction={"column"} justifyContent={"center"} rowSpacing={{
            xs: 2,
            sm: 2,
            md: 2
        }} 
            sx={{
                overflow: 'auto',
                px: 2,
                pb: 10
            }}
        >
            <Grid item>
            <ProfileCard 
                    {...this.props}
                    profile={this.props.profile}
                    lang={this.props.lang.profile}
                />

            </Grid>

           
            <Grid item>
                <Stack
                    sx={{
                        bgcolor: 'background.light',
                        boxShadow: 2,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alighItems: 'center',
                        width: '100%',
                        // height: {
                        //     md: '64px',
                        //     sm: '64px',
                        //     xs: '36px'
                        // },
                        m: 'auto'
                    }}
                >
                    <Box
                        sx={{
                            // bgcolor: 'background.default',
                            height: {
                                md: '64px',
                                sm: '64px',
                                xs: '36px'
                            },
                            width: {
                                md: '64px',
                                sm: '64px',
                                xs: '36px'
                            },
                            mx: {
                                md: 1,
                                sm: 1,
                                xs: 1
                            },
                            my: 'auto'
                        }}
                    >
                        <Icons.SupportMsgIcon2 style={{ width: '100%' }} />
                    </Box>
                    <Paragraph variant="h6" style={{
                        marginTop: 'auto',
                        marginBottom: 'auto'
                    }}>{this.props.hasOwnProperty('supportiveMessages') && this.props.supportiveMessages !== null ? `${this.props.supportiveMessages.length} ${lang.supportMessages}`: lang.supportMessagesComing}</Paragraph>

                </Stack>

            </Grid>

            <Grid item>
                <Grid container direction={"column"} rowSpacing={2}>
                    {this.state.loaded ? supportiveMessages:<CircularProgress />}
                </Grid>
            </Grid>

            <ConfirmBox 
                confirmTitle={this.props.confirmMessage.title || ''}
                confirmMsg={this.props.confirmMessage.value || ''}
                close={() => this.props.initConfirmMessage({})} 
                confirm={() => {
                    this.props.initConfirmMessage({})
                    this.props.storePayloadBeforeConfirm({})
                }}
                component={this.state.modalComponent || null}
                cancel={() => {
                    this.props.initConfirmMessage({})
                    this.props.storePayloadBeforeConfirm({})
                }} 
            />

        </Grid>
        </Box>)
        }
}

/*
const SupportiveMessages = props => {
    const date = new Date(props.time)
    return (<><Grid item xs={10} className='d-flex mx-auto my-3'>

        <Grid item xs={2}>
            <div className='match-avatar-sm mx-auto'>
                <Text className='p-0 m-0'>{props.display_name.length > 1 ? `${props.display_name[0].toUpperCase()}${props.display_name[1].toUpperCase()}`:`${props.display_name[0].toUpperCase()}`}</Text>
            </div>
        </Grid>

        <Grid item xs={10} className='supportive-message-bubble p-3'>
            <Text className='p-0 m-0'>{props.message}</Text>
        </Grid>

        </Grid>
        
        <Grid item xs={10} className='mx-auto d-flex justify-content-end'>
            <Tip>{STM.convertTimeToString(date)}</Tip>
        </Grid>
    
    </>)
}
*/
export default Profile